import React, { useEffect, useState } from "react";
import Header from "../header/Header";
import Login from "../../pages/login/LoginForm";
import OtpScreen from "../../pages/login/OtpScreen";
import ForgotPassword from "../../pages/login/ForgotPassword";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import BreadCrumbs from "../../generalComponnets/breadCrumbs/BreadCrumbs";
import LoginHeader from "../header/LoginHeader";

export default function LogoOnlyLayout() {
  const [currentPage, setCurrentPage] = useState("login");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const token = localStorage.getItem("token");
  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, []);

  return (
    <>
      <LoginHeader />
      <div className="color-black ">
        <Outlet className="container-fluid" />
      </div>
      <div className="layout-container"></div>
    </>
  );
}
